document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("OccasionForm");
    const eventsList = document.getElementById("events-list").querySelector('tbody');
    const customerId = form.querySelector("[name='customer_id']").value;

    const today = new Date().toISOString().split("T")[0];

    function formatDateDisplay(dateStr) {
        const date = new Date(dateStr); // ev.event_date = "2025-09-11"
        return date.toLocaleDateString("lt-LT", {
            day: "numeric",
            month: "long",
            year: "numeric"
        }).replace(" d.", "");
    }

    function loadEvents() {
        fetch("https://littlewhile.rav.lt/wp-admin/admin-ajax.php?action=get_events&customer_id=" + customerId)
            .then(res => res.json())
            .then(data => {
                eventsList.innerHTML = "";
                if (data.success && data.data.length > 0) {
                    data.data.forEach(ev => {
                        const isToday = ev.event_date === today;
                        const displayDate = formatDateDisplay(ev.event_date);
                        eventsList.innerHTML += `
                                <tr class="occasion-item${isToday ? " date-today" : ""}">
                                    <td class="dot-legend"><span></span></td>
                                     <td class="date-display">${displayDate}</td>
                                    <td class="title-display">${ev.title}</td>
                                    <td class="for-display">${ev.for_who}</td>
                                </tr>`;
                    });
                } else {
                    eventsList.innerHTML = "<tr><td colspan='4'>No events found.</td></tr>";
                }
            });
    }

    // Load initial events
    loadEvents();

    // Submit form
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        const formData = new FormData(form);
        console.log([...formData.entries()]);

        fetch("https://littlewhile.rav.lt/wp-admin/admin-ajax.php?action=save_event", {
            method: "POST",
            body: formData
        })
        .then(res => res.text()) // get raw text first
        .then(text => {
            console.log("RAW response:", text);
            try {
                const data = JSON.parse(text);
                console.log("Parsed JSON:", data);

                if (data.success) {
                    form.reset();
                    loadEvents();
                }
            } catch (e) {
                console.error("JSON parse error:", e);
            }
        });

    });
});
